import { IconPlus } from "@synthesis/shared-icons";
import { Button } from "@synthesis/shared-ui";

import { usePageStore } from "../constructor-documents-page.lib";

/** Панель действий «Документы»: кнопка добавления комплекта (модалка открывается через стор). */
export const ConstructorDocumentsToolbar = () => {
  const store = usePageStore()!;

  return (
    <div className="flex items-center justify-end">
      <Button
        theme="primary"
        size="sm"
        leftIcon={<IconPlus className="size-5" aria-hidden />}
        onClick={() => store.setPopupAction({ type: "add-document-kit" })}
      >
        Добавить комплект
      </Button>
    </div>
  );
};
